export default "__VITE_ASSET__rwzSDOhe__$_?url__"